import { createContext } from 'react'
import { AuthStore } from './AuthStore'
import { UserStore } from './UserStore'
import { CommonConfigStore } from './CommonConfigStore'
import { FundStore } from './FundStore'
import { OrderStore } from './OrderStore'

export const stores = Object.freeze({
   AuthStore: new AuthStore(),
   FundStore: new FundStore(),
   UserStore: new UserStore(),
   CommonConfigStore: new CommonConfigStore(),
   OrderStore: new OrderStore()
})

export const storesContext = createContext(stores)
export const StoresProvider = storesContext.Provider
